/**
 * Approval Category Codes for Payroll Processing
 *
 * These codes determine which approval workflow is triggered
 * when a payroll file is submitted for approval.
 */

export const APPROVAL_CATEGORY_CODES = {
  /**
   * Standard payroll file system approval workflow
   * Used for: Regular BU Maker/Checker flows
   * Workflow: BU Maker → BU Checker → BU Approver → PaymentOps
   */
  PAYROLL_FILE_SYSTEM: "PayrollFileSystem",

  /**
   * PSP (Payment Service Provider) payroll file system approval workflow
   * Used for: PSP Maker/Checker flows
   * Workflow: PSP Maker → PSP Checker → BU Approver → PaymentOps
   */
  PAYROLL_FILE_SYSTEM_PSP: "PayrollFileSystemPSP",
} as const;

export type ApprovalCategoryCode = typeof APPROVAL_CATEGORY_CODES[keyof typeof APPROVAL_CATEGORY_CODES];
